import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import * as properties from '../constants/Properties'
import { setConfirmModal } from '../actions/generalActions'
import { getTranslation } from '../actions/dataActions'
import * as resource from '../constants/Resources'
import PropTypes from 'prop-types'

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.confirmTap = this.confirmTap.bind(this);
    this.cancelTap = this.cancelTap.bind(this);
  }

  confirmTap() {
    const confirm = this.props.confirmModal.confirm;
    let confirmParam = this.props.confirmModal.confirmparam;
    const dispatch = this.props.confirmModal.dispatch;
    if (confirmParam === null) {
      confirmParam = [];
    }

    this.props.setConfirmModal('', null, null);

    if (confirm !== null) {
      if (dispatch !== null) {
        dispatch(confirm.apply(this, confirmParam));
      }
      confirm.apply(this, confirmParam);
    }
  }

  cancelTap() {
    const cancel = this.props.confirmModal.cancel;
    const dispatch = this.props.confirmModal.dispatch;
    let cancelParam = this.props.confirmModal.cancelparam;
    if (cancelParam === null) {
      cancelParam = [];
    }

    this.props.setConfirmModal('', null, null);

    if (cancel !== null) {
      if (dispatch !== null) {
        dispatch(cancel.apply(this, cancelParam));
      }
      cancel.apply(this, cancelParam);
    }
  }

  render() {
    const labelYes = this.props.getTranslation(resource.LABEL_YES);
    const labelNo = this.props.getTranslation(resource.LABEL_NO);
    return (
      <Modal id="reactModal"
        contentLabel=""
        isOpen={this.props.confirmModal.show}
        style={properties.confirmModalStyle}
      >
        <div className="modalContent">
          <div className="modalText">{this.props.confirmModal.message}</div>
          <div className="modalButtons">
            <button className="modalButton approve" onClick={this.confirmTap}>
              {labelYes}
            </button>
            <button className="modalButton deny" onClick={this.cancelTap}>
              {labelNo}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

ConfirmModal.propTypes = {
  confirmModal: PropTypes.object.isRequired,
  setConfirmModal: PropTypes.func
}
function mapStateToProps(state) {
  return {
    confirmModal: state.generalState.modal.confirmModal
  }
}

export default connect(mapStateToProps, { setConfirmModal, getTranslation })(ConfirmModal)



// WEBPACK FOOTER //
// src/components/ConfirmModal.jsx